import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CashReceiptForm from '../../components/pageModule/Cashreceipts/CashReceiptForm';
import { createCashReceipt, setSelected, clearCurrentCashReceipt } from '../../store/modules/cashreceipt/cashreceiptActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const CashreceiptsCreate = () => {
    const initialData = useRef({ 
        initialType: 'create',
        payment_date: new Date().toISOString().split('T')[0],
        payment_method: {
            'id': 'cheque',
            'label': 'Cheque'
        } 
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Clear any existing data when component mounts
    useEffect(() => {
        dispatch(clearCurrentCashReceipt());
    }, [dispatch]);

    const handleCreate = async (formData) => {
        try {
            const response = await dispatch(createCashReceipt(formData));
            toast.success('Cash receipt created successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            if (response && response.id) {
                navigate(`/cash_receipts/edit/${response.id}`);
            }
            return response;
        } catch (error) {
            toast.error(error.message || 'Error creating cash receipt', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
    };
    
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <CashReceiptForm 
                                    initialData={initialData.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.create(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CashreceiptsCreate; 